export const DarkIdPolo =
  'https://assets.volkswagen.com/is/image/volkswagenag/img_id-polo?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx';

export const LightIdPolo =
  'https://assets.volkswagen.com/is/image/volkswagenag/img_polo?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx';

export const LightSpiral =
  'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-id-mirror/light-spiral.svg';

export const DarkSpiral =
  'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-id-mirror/dark-spiral.svg';

export const DarkC1Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_01_img_card_1920x1080px?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';

export const DarkC2Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_02_img_card_1920x1080px?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';

export const DarkC3Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_03_img_card_1920x1080px?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';

export const LightC1Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_01_img_card_1920x1080px-1?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';

export const LightC2Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_02_img_card_1920x1080px-1?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';

export const LightC3Image =
  'https://assets.volkswagen.com/is/image/volkswagenag/01_03_img_card_1920x1080px-1?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=';
